import { Link, useParams, useSearchParams } from "react-router-dom";
import { Meta } from "../components/Meta";
import { ProductDetails } from "../components/ProductDetails";
import { productPath, routes } from "../config/routes";
import { findVisibleProduct, isPublished } from "../data/catalogue";

export function ProductPage({ bundleOnly = false }: { bundleOnly?: boolean }) {
  const { slug } = useParams();
  const [searchParams] = useSearchParams();
  const legacyId = searchParams.get("id");
  const querySlug = searchParams.get("slug");
  const product =
    findVisibleProduct(slug) ||
    findVisibleProduct(querySlug ?? "") ||
    findVisibleProduct(legacyId ?? "");

  if (!product || bundleOnly) {
    return (
      <main id="main" className="content-page">
        <Meta
          title="Listing not available | Beautify Ourselves"
          description="This Beautify Ourselves listing is not available."
          path={slug ? (bundleOnly ? `/bundles/${slug}` : productPath(slug)) : routes.productHtml}
          noIndex
        />
        <div className="empty-state">
          <p className="eyebrow">The collection</p>
          <h1>{bundleOnly ? "Bundle pages are not in use." : "This product is not listed yet."}</h1>
          <p>
            {bundleOnly
              ? "Named sets appear as a single preview listing on a product page. Contents are not listed until they are verified."
              : "Explore the preview catalogue while we prepare approved product pages."}
          </p>
          <Link className="button" to={routes.shop}>
            Browse the collection
          </Link>
        </div>
      </main>
    );
  }

  const description = product.description
    ? `${product.description} Preview listing; orders are not currently available.`
    : [product.name, product.packSize, "Preview listing from Beautify Ourselves. Orders are not currently available."]
        .filter(Boolean)
        .join(". ");

  return (
    <main id="main">
      <Meta
        title={`${product.name} | Beautify Ourselves`}
        description={description}
        path={productPath(product.slug)}
        noIndex={!isPublished(product)}
      />
      <ProductDetails product={product} />
    </main>
  );
}
